import getInvalidNotHiddenFormFields from '../../user/helpers/getInvalidNotHiddenFormFields'

function validateRegistrationFields({ state, output, input }) {
  const { currentPage } = input
  const fields = getInvalidNotHiddenFormFields(
    state.get(`client.registrating.current.${currentPage}`)
  )
  Object.keys(fields).forEach(field => {
    state.set(
      `client.registrating.current.${currentPage}.${field}.isTouched`,
      true
    )
  })
  if (Object.keys(fields).length > 0) {
    output.false()
  } else {
    output.true()
  }
}
validateRegistrationFields.outputs = ['true', 'false']
export default validateRegistrationFields



// WEBPACK FOOTER //
// ./src/modules/login/actions/validateRegistrationFields.js